import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["headerText"];

    connect() {
        this.createBackNavigationListner();
    }

    createBackNavigationListner() {
        window.addEventListener('message', this.processWidgetNavigationMessage, false);
    }

    processWidgetNavigationMessage(message) {
        try {
            let json = JSON.parse(message.data);
            if (json.type === "history") {
                window.history.back();
            }
        } catch {
            // If it cannot be parsed then ignore the event
        }
    }
}